export const faqs = [
  {
    id: "q1",
    q: "「欧美伦理电影」在线包含哪些内容？",
    a: "在本站语境里，它主要指以家庭、婚姻、禁忌关系、都市欲望与道德困境为核心的欧美剧情片，以及围绕这些影片的定义、题材细分、分级尺度、代表作品与版本差异。它不是一种严格分类，而是一个便于检索的内容方向。",
  },
  {
    id: "q2",
    q: "什么是「未删减版」？它一定更好吗？",
    a: "未删减通常指相对院线版补回了被剪掉的段落。它能让动机与情绪更完整，但并不意味着一定更好看——更长的篇幅也可能带来节奏拖沓。是否值得，取决于你更在意叙事密度还是角色完整性。",
  },
  {
    id: "q3",
    q: "大尺度就等于低俗吗？",
    a: "不一定。尺度只是内容呈现的开放程度，本身不构成质量判断。关键在于这些场面是否服务于人物与主题：为叙事必要而存在的呈现，与纯粹为吸引眼球而堆砌的呈现，观感完全不同。判断标准应回到作品想表达什么。",
  },
  {
    id: "q4",
    q: "伦理电影和情色片有什么区别？",
    a: "核心差别在目的。伦理电影把亲密与欲望当作理解人性、关系与社会的入口，重心在人物与主题；而情色片以感官刺激为主要目的。同一部影片可能同时被两方讨论，因此真正有用的是自己判断它把镜头对准了什么。",
  },
  {
    id: "q5",
    q: "怎么判断一部影片是否适合自己观看？",
    a: "先看分级（如 R、NC-17），它标注了内容强度；再读剧情简介与主题标签，判断是否触及自己不适应的议题。如果对某些情节敏感，可以先了解版本次别与大致走向，再决定是否观看。",
  },
  {
    id: "q6",
    q: "为什么同一部电影会有好几个版本？",
    a: "原因通常有三类：分级与市场审查导致的删减、导演对成品的重新剪辑、以及不同国家分级制度带来的地区差异。所以你会同时看到院线版、导演剪辑版、延长版等，时长与部分画面可能相差明显。",
  },
  {
    id: "q7",
    q: "观看这类影片需要什么心态？",
    a: "把它们当作理解复杂人性的文本，而不是寻求简单道德结论。优秀的伦理片往往让判断变得困难——那不是缺陷，而是它希望你带着问题离开，而不是带着答案。",
  },
];